import React from "react";
import MonthlyReport from "../layout/MonthlyReport";

function MonthlyReportPage() {
    return (
        <MonthlyReport />
    )
}

export default MonthlyReportPage;